import { render, staticRenderFns } from "./BaseExpansionPanels.vue?vue&type=template&id=381fb4f8&scoped=true&"
import script from "./BaseExpansionPanels.vue?vue&type=script&lang=js&"
export * from "./BaseExpansionPanels.vue?vue&type=script&lang=js&"
import style0 from "./BaseExpansionPanels.vue?vue&type=style&index=0&id=381fb4f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381fb4f8",
  null
  
)

export default component.exports